<div class="login row">
  <div class="BGLogin col">
    <img alt="Background Login" src="assets/svg/BG-Login.png"/>
  </div>
  <div class="Login_BoxForm col-3">
    <div class="BoxForm_Content">
      <div class="BoxForm_Title">
        <img alt="Icon Login" src="assets/svg/icon_login.svg">
        <p>Olá, bem-vindo</p>
      </div>
      <div class="BoxForm_Form">
        <div class="choose">
          @if (isAtendimentoRoute) {
            <div class="col-11 button-group">
              <app-generic-button-v2 [buttonSettings]="buttonLoginBackoffice" />
            </div>
          } @else {
            <div class="label">Escolha uma opção:</div>
            <div class="col-11 button-group">
              <app-generic-button-v2 [buttonSettings]="buttonFirstAccess" />
              <app-generic-button-v2 [buttonSettings]="buttonLogin" />
            </div>
            @if (isTestEnv) {
              <div>
                <input aria-label="Identificação de Automação" #inputIdentify type="text" id="input-identify" data-e2e="input-identify" [hidden]="true"/>
              </div>
            }
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="edenredMobile">
        <img alt="Logo Edenred" src="assets/svg/logo-edenred.svg"/>
        <img alt="Logo Ticket Log" src="assets/svg/logo-ticket-log.svg"/>
      </div>
    </div>
  </div>
</div>

